// Local translations
export const T = {
  en_GB: {
    title: "Duplicate Risk Model",
    description:
      "Create a copy of this model with its time horizons, risk levels, matrix scores, adjustment questions, risk bounds, cap rule and input scope settings. The copy starts inactive, so its input scope can still be changed.",
    name: "Name",
    modelDescription: "Description (optional)",
    descriptionPlaceholder: "Describe what this risk model is used for",
    cancel: "Cancel",
    duplicate: "Duplicate",
    error: "Error",
    failedToDuplicate: "Failed to duplicate risk model",
  },
  nb_NO: {
    title: "Dupliser risikomodell",
    description:
      "Opprett en kopi av denne modellen med tidshorisonter, risikonivåer, matrisepoeng, justeringsspørsmål, risikogrenser, tak-regel og omfang for inndata. Kopien starter som inaktiv, slik at omfanget fortsatt kan endres.",
    name: "Navn",
    modelDescription: "Beskrivelse (valgfritt)",
    descriptionPlaceholder: "Beskriv hva denne risikomodellen brukes til",
    cancel: "Avbryt",
    duplicate: "Dupliser",
    error: "Feil",
    failedToDuplicate: "Kunne ikke duplisere risikomodell",
  },
} as const;
